import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { createContext, useContext, useMemo } from "react";
import { connect } from "react-redux";
import actions from "../store/actions/app/actions";
import * as asyncActions from "../store/actions/app/asyncActions";
import bindActionCreators from "../util/bindActionCreators";
const AppContext = createContext();
const AppContextProvider = props => {
  const {
    actions,
    appState,
    asyncActions,
    children
  } = props;
  const appApi = useMemo(() => _objectSpread({
    actions
  }, asyncActions), [actions, asyncActions]);
  const contextValue = useMemo(() => [appState, appApi], [appApi, appState]);
  return /*#__PURE__*/React.createElement(AppContext.Provider, {
    value: contextValue
  }, children);
};
const mapStateToProps = _ref => {
  let {
    app
  } = _ref;
  return {
    appState: app
  };
};
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
  asyncActions: bindActionCreators(asyncActions, dispatch)
});
export default connect(mapStateToProps, mapDispatchToProps)(AppContextProvider);
export const useAppContext = () => useContext(AppContext);